import { useState, useContext, useEffect } from "react";
import { Container } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { AppDispatch, RootState } from "../../../slices/store";
import { TodosContext } from "../../../context";
import useRequestSettings from "../../../hooks/useRequestClient";
import useUserParams from "../../../hooks/useSingleUserParams";
import { clientsGet } from "../../../slices/clients/clientManagementSlice";
import { handleDeleteClientService } from "../../client-management/service/clientService";
import { SelectedUser } from "../../../slices/users/types";
import { getSingleUser } from "../../../slices/users/userManagementSlice";
import {
  BUTTONS,
  DELETE_MODAL_SUB_TITLE,
  DELETE_MODAL_TITLE,
  contentDetails,
} from "./constants";
import UseAuthConfig from "../../../hooks/useAuthConfig";
import { ContentDetail } from "../../../components/templates/DetailsSection/types";
import BreadCrumb from "../../../components/organisms/Breadcrumb/BreadCrumb";
import Headline from "../../../components/organisms/Headline/Headline";
import Loader from "../../../components/atoms/Loader/Loader";
import DetailsSection from "../../../components/templates/DetailsSection/DetailsSection";
import DeleteModal from "../../../components/organisms/DeleteModal/DeleteModal";

const UserDetails = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch<AppDispatch>();
  const selectedUser = useSelector(
    (state: RootState) => state.userManagement.selectedUser
  );
  const [isConfirmationModalShow, setIsConfirmationModalShow] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const { addAlert } = useContext(TodosContext);
  const [reqRequests] = useRequestSettings();
  const getSingleUserParams = useUserParams(4);
  const { protectedResources }: any = UseAuthConfig();

  useEffect(() => {
    if (!selectedUser && getSingleUserParams) {
      dispatch(getSingleUser(getSingleUserParams));
    }
  }, [dispatch, getSingleUserParams, selectedUser]);

  const handleOpenModal = () => setIsConfirmationModalShow(true);
  const handleCloseModal = () => setIsConfirmationModalShow(false);

  const detailsValueGenerator = (item: ContentDetail) => {
    const { name } = item;
    if (!selectedUser || !name) return;

    const value = selectedUser[name as keyof SelectedUser];
    if (name === "firstName" && selectedUser.lastName) {
      return `${selectedUser.firstName} ${selectedUser.lastName}`;
    }
    return value;
  };

  const handleMainButtonClick = (buttonType: string) => {
    if (buttonType === "Back") {
      return navigate(-1);
    } else if (buttonType === "Delete") {
      handleOpenModal();
    }
  };

  const handleConfirm = () => {
    handleDeleteClientService(
      selectedUser,
      reqRequests,
      setIsLoading,
      dispatch,
      addAlert,
      true,
      navigate,
      clientsGet,
      protectedResources
    );
    handleCloseModal();
  };

  return (
    <Container fluid className="layout-bar">
      <BreadCrumb />
      <Headline name="User details"/>
      {isLoading ? (
        <Loader />
      ) : (
        <DetailsSection
          BUTTONS={BUTTONS}
          DetailsValueGenerator={detailsValueGenerator}
          contentDetails={contentDetails}
          handleMainButtonClick={handleMainButtonClick}
          title={`${selectedUser?.firstName} ${selectedUser?.lastName}`}
        />
      )}
      <DeleteModal
        title={DELETE_MODAL_TITLE}
        subTitle={DELETE_MODAL_SUB_TITLE}
        show={isConfirmationModalShow}
        onClose={handleCloseModal}
        onConfirm={handleConfirm}
      />
    </Container>
  );
};

export default UserDetails;
